"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Icon2 = require("../svg/Icon");
var _common = require("../utility/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Header = function Header() {
  return null;
};
Header.displayName = "Header";
var Body = function Body() {
  return null;
};
Body.displayName = "Body";
var Footer = function Footer() {
  return null;
};
Footer.displayName = "Footer";
var largeScreen = 768;
var mediumScreen = 500;
var smallScreen = 375;
var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);
  var _super = _createSuper(Modal);
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _super.call(this, props);
    _this.state = {
      modalSizeClass: _this.props.size ? _this.getModalClass(_this.props.size) : 'tl-large'
    };
    return _this;
  }
  _createClass(Modal, [{
    key: "closeModal",
    value: function closeModal() {
      var modalType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'alert-modal-default';
      var isOpen = arguments.length > 1 ? arguments[1] : undefined;
      this.props.onShowModal && this.props.onShowModal(modalType, isOpen);
    }
  }, {
    key: "getModalClass",
    value: function getModalClass() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'large';
      var modalSize = 'tl-large';
      if (size === 'large') {
        modalSize = 'tl-large';
      } else if (size === 'medium') {
        modalSize = 'tl-medium';
      } else if (size === 'small') {
        modalSize = 'tl-small';
      } else if (size === 'xSmall') {
        modalSize = 'tl-xSmall';
      }
      return modalSize;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this2 = this;
      var header = this.props.children && this.props.children[0];
      if (!header) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header.props.children || header.props.titleIcon ? /*#__PURE__*/_react.default.createElement("div", {
        className: header.props.headerClass ? "tl-modal-title heading24 ui-modal-title " + header.props.headerClass : "tl-modal-title heading24 ui-modal-title ",
        id: "dialogTitle"
      }, header.props.titleIcon ? /*#__PURE__*/_react.default.createElement(_Icon2.SvgIcon, {
        name: header.props.titleIcon,
        className: "tl-svg-info-icon"
      }) : '', header.props.children) : null, header.props.isClosable === false ? '' : /*#__PURE__*/_react.default.createElement("span", {
        "aria-label": "close-modal"
      }, " ", /*#__PURE__*/_react.default.createElement("svg", {
        className: "tl-modal-icon-svg ui-modal-cross-button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.closeModal(_this2.props.modalType, false);
        }
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "icon-system-close"
      }))), " ");
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var body = this.props.children && this.props.children[1];
      if (!body) {
        return null;
      }
      return body.props.children;
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var footer = this.props.children && this.props.children[2];
      if (!footer) {
        return null;
      }
      return footer.props.children;
    }
  }, {
    key: "getOverlayClass",
    value: function getOverlayClass() {
      var modalOverlayClass = "tl-modal-overlay tl-closed";
      if (this.props.isOverlay !== false && this.props.isOpen) {
        modalOverlayClass = "tl-modal-overlay";
      }
      return modalOverlayClass;
    }
  }, {
    key: "getModelClass",
    value: function getModelClass() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'large';
      var msgBodyLength = this.props.children && this.props.children[1] ? this.props.children[1].props.children.length : '';
      var modalBodyClass = msgBodyLength > 100 ? 'tl-height-large' : 'tl-height-small';
      var defaultModalClass = "tl-modal tl-modal-dialog-scrollable tl-modal-dialog tl-show-modal-popup ".concat(modalBodyClass, " ");
      return defaultModalClass;
    }
  }, {
    key: "stopBgScroll",
    value: function stopBgScroll(modalType, modalStatus) {
      if (this.props.preventBackgroundScroll) {
        var BODY_CLASS_MODAL_OPEN = 'tl-modal-prevent-scroll';
        if (modalStatus) {
          document.body.classList.add(BODY_CLASS_MODAL_OPEN);
        } else {
          document.body.classList.remove(BODY_CLASS_MODAL_OPEN);
        }
      }
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      var modalClass = '';
      var modalClassProp = this.getModalClass(this.props.size);
      var windownInnerwidth = window.innerWidth;
      if (windownInnerwidth < smallScreen) {
        modalClass = 'tl-xSmall';
      } else if (windownInnerwidth >= smallScreen && windownInnerwidth < mediumScreen) {
        if (modalClassProp === 'tl-xSmall') {
          modalClass = modalClassProp;
        } else {
          modalClass = 'tl-small';
        }
      } else if (windownInnerwidth >= mediumScreen && windownInnerwidth < largeScreen) {
        if (modalClassProp === 'tl-xSmall' || modalClassProp === 'tl-small') {
          modalClass = modalClassProp;
        } else {
          modalClass = 'tl-medium';
        }
      } else {
        modalClass = modalClassProp ? modalClassProp : 'tl-large';
      }
      this.setState({
        modalSizeClass: modalClass
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions.bind(this));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var modalOverlayClass = this.getOverlayClass();
      var isCloseOnOverlayClick = this.props.isCloseOnOverlayClick ? this.props.isCloseOnOverlayClick : false;
      var gradientClassName = this.props.modalType === "alert-modal-warning" ? "tl-modal-header-warning" : "tl-modal-header-gradient";
      var modalBoxClass = (0, _common.classNames)(this.getModelClass(this.props.size), this.state.modalSizeClass);
      modalBoxClass = this.props.className ? (0, _common.classNames)(modalBoxClass, this.props.className) : (0, _common.classNames)(modalBoxClass, ' ui-modal-container');
      var modalOuterBoxClass;
      if (this.props.isOpen) {
        modalOuterBoxClass = "tl-modal-box-container";
        this.stopBgScroll(this.props.modalType, true);
      } else {
        modalOuterBoxClass = "tl-modal-box-container tl-closed";
        this.stopBgScroll(this.props.modalType, false);
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-modalbox-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: modalOverlayClass,
        onClick: function onClick() {
          return _this3.closeModal(_this3.props.modalType, isCloseOnOverlayClick);
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: modalOuterBoxClass,
        id: this.props.id,
        tabIndex: -1,
        role: "dialog",
        "aria-labelledby": "dialogTitle",
        "aria-describedby": "dialogDesc",
        "aria-hidden": "true"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: modalBoxClass
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: gradientClassName,
        id: "modal_gradient"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-modal-header"
      }, this.renderHeader()), /*#__PURE__*/_react.default.createElement("div", {
        className: "body18 tl-modal-body ui-modal-message",
        id: "dialogDesc"
      }, this.renderBody()), /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-modal-footer ui-modal-footer tl-modal-footer-center"
      }, this.renderFooter())))));
    }
  }], [{
    key: "Header",
    value: function Header(content) {
      return content;
    }
  }, {
    key: "Body",
    value: function Body(content) {
      return content;
    }
  }, {
    key: "Footer",
    value: function Footer(content) {
      return content;
    }
  }]);
  return Modal;
}(_react.default.Component);
exports.default = Modal;